import classNames from 'classnames';
import React, { ReactElement, ReactNode } from 'react';
import { NavLink, Link as RouterLink } from 'react-router-dom';
import './Link.scss';
import ILinkProps from './LinkProps';

const Link = ({ tag = 'a', href, primary = true, underline = false, children, className, exact = true, newTab = false, ...other }: ILinkProps) => {
  const classes = classNames(
    'link',
    {
      'link-primary': primary,
      'link-underline': underline,
    },
    className
  );

  function renderLink(): ReactNode {
    if (tag !== 'a' && tag !== 'div') {
      const linkProps = {
        className: classes,
        to: href,
        exact,
        target: newTab ? '_blank' : '_self',
        ...other,
      };

      if (tag === 'NavLink') {
        return React.createElement(NavLink, { ...linkProps }, children);
      } else if (tag === 'Link') {
        return React.createElement(RouterLink, { ...linkProps }, children);
      }
    }

    return React.createElement(
      tag,
      { className: classes, href, target: newTab ? '_blank' : '_self', ...other },
      children
    )!;
  }

  return renderLink() as ReactElement;
};

export default Link;
